module.exports = __webpack_public_path__ + "img/Software Development.448c85c3.png";